export type BudgetImportField = 'designation' | 'quantity' | 'unit' | 'number';

export interface ColumnMappingEntry {
    excelColumnIndex: number;
    excelColumnName: string;
    budgetField: BudgetImportField | null;
}

export interface BudgetColumnMapping {
    mappings: ColumnMappingEntry[];
    headerRowNumber: number;
    fileName: string;
    importedAt: string;
}

export interface ExcelSheetData {
    sheetName: string;
    rows: string[][];
    rawRows?: string[][];
    // Cell formula text (OOXML canonical: English function names, ',' arg separator, '.' decimals,
    // no leading '='). Empty string when the cell has no formula. Aligned with `rows`.
    formulaRows?: string[][];
    columnCount: number;
}

export interface ImportRow {
    rowIndex: number;
    type: 'S' | 'O' | null;
    rawCells: string[];
}

export const BUDGET_IMPORT_FIELDS: { value: BudgetImportField; labelKey: string }[] = [
    { value: 'designation', labelKey: 'budgets.budget.import_structure.field_designation' },
    { value: 'quantity', labelKey: 'budgets.budget.import_structure.field_quantity' },
    { value: 'unit', labelKey: 'budgets.budget.import_structure.field_unit' },
    { value: 'number', labelKey: 'budgets.budget.import_structure.field_number' },
];
